import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://techovarya.com";
const DEFAULT_IMAGE =
  "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&w=1200&h=630&fit=crop";

/**
 * Per-route SEO. Injects title, description, canonical, Open Graph and
 * Twitter tags. Google renders client-side JS, so these are picked up for
 * indexing; the static index.html covers social scrapers for the homepage.
 */
export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, type = "website", jsonLd }) => {
  const fullTitle = title ? `${title} | Techovarya` : "Techovarya | AI-Native Product Engineering & SaaS Development";
  const url = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Techovarya" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
